import { Link } from "react-router-dom";
import { FaPhone, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-obsidian border-t border-white/5" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="space-y-6">
            <Link to="/" className="flex items-center gap-3">
              <img
                src="/images/logo-56.webp"
                alt="Crown Amusement"
                className="h-14 w-auto"
                width="56"
                height="56"
              />
              <div className="flex flex-col">
                <span className="font-heading text-xl text-gold-500 leading-tight tracking-wide">CROWN</span>
                <span className="font-heading text-sm text-white leading-tight tracking-widest">AMUSEMENT</span>
              </div>
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed">
              Industry leaders in skill game manufacturing, vending, and online gaming solutions. 
              Crafting premium entertainment experiences since establishment.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-heading text-lg text-white mb-6">Quick Links</h3>
            <ul className="space-y-3">
              {[
                { name: "Cabinets", path: "/products" },
                { name: "Kiosks", path: "/kiosks" },
                { name: "Gameboards", path: "/gameboards" },
                { name: "Manufacturing", path: "/manufacturing" },
                { name: "About Us", path: "/about" },
                { name: "Blog", path: "/blog" },
                { name: "Contact", path: "/contact" },
              ].map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-gray-400 hover:text-gold-500 transition-colors text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Products */}
          <div>
            <h3 className="font-heading text-lg text-white mb-6">Products</h3>
            <ul className="space-y-3">
              {[
                { name: "Cabinets", path: "/products?cat=cabinet" },
                { name: "Kiosks", path: "/products?cat=kiosk&sub=ticket_redemption" },
                { name: "Arcade", path: "/products?cat=arcade&sub=coin_pusher" },
                { name: "Gameboards", path: "/products?cat=gameboard&sub=all" },
                { name: "Gaming Systems", path: "/products?cat=gaming_system" },
              ].map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-gray-400 hover:text-gold-500 transition-colors text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-heading text-lg text-white mb-6">Contact</h3>
            <ul className="space-y-4">
              <li>
                <a
                  href="tel:+18482198830"
                  className="flex items-center gap-3 text-gray-400 hover:text-gold-500 transition-colors text-sm"
                  data-testid="footer-phone"
                >
                  <FaPhone className="text-gold-500" />
                  +1 848-219-8830
                </a>
              </li>
              <li>
                <a
                  href="mailto:info@crownamusement.com"
                  className="flex items-center gap-3 text-gray-400 hover:text-gold-500 transition-colors text-sm"
                  data-testid="footer-email"
                >
                  <FaEnvelope className="text-gold-500" />
                  info@crownamusement.com
                </a>
              </li>
              <li>
                <div className="flex items-start gap-3 text-gray-400 text-sm">
                  <FaMapMarkerAlt className="text-gold-500 mt-0.5" />
                  <span>United States</span>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-white/5">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-500 text-sm">
              Copyright {currentYear} Crown Amusement. All rights reserved.
            </p>
            <div className="flex gap-6">
              <Link to="/privacy" className="text-gray-500 hover:text-gray-400 text-sm">
                Privacy Policy
              </Link>
              <Link to="/terms" className="text-gray-500 hover:text-gray-400 text-sm">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
